module.exports = __webpack_public_path__ + "img/btn_facebook_wing.8653ac96.png";